<div
  class="flex justify-content-around flex-wrap h-screen align-content-center">
  <app-login-form [redirect]="true"></app-login-form>
</div>
<app-footer />
